@if (this.leadDetail$ | async; as leadDetail) {
  <div class="sub-header">
    <div class="sub-header-row border-top align-items-center px-1">
      <div class="row">
        @if (this.customActions$ | async; as customActions) {
          <div class="col">
            <!--        href="https://www.comparanoo.re/offres-mutuelles-sante?leadId={{this.leadUniqueId}}" target="_blank"-->
            @for (action of customActions; track action.actionName) {
              <a
                [class]="action.buttonType | buttontypepipe"
                class="btn-sm btn"
          (click)="
            triggerStatusFlow(
              action.actionName,
              leadDetail.id,
              leadDetail.productCategoryId
            )
          "
                >
                {{ action.title }}
              </a>
            }
            @if (
              leadDetail.uniqueId &&
              leadDetail.category === InsuranceCategory.Health &&
              leadDetail.leadStatus != 'Lost'
              ) {
              <a
                class="btn-sm btn btn-outline-primary mr-2"
          href="{{ this.comparanooUrl }}/offres-mutuelles-sante?leadId={{
            leadDetail.uniqueId
          }}"
                target="_blank"
                translate
                >
                GLOBAL_BTN_SEE_OFFERS
              </a>
            }
          </div>
        }
        @if (this.leadStatusFlows$ | async; as leadStatus) {
          <div
            class="col-auto state-breadcrumb-col"
            >
            <div class="state-breadcrumb">
              @for (leadStatus of leadStatus; track leadStatus.status) {
                <li
            [ngClass]="
              leadDetail.leadStatus == leadStatus.status
                ? ['active-' + leadStatus.statusColor]
                : ''
            "
                  >
                  {{ leadStatus.label }}
                </li>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
